import { BaseEntity, ObjType } from "./BaseEntity";

/** ロックステータス */
export const LOCK_STATUS: ObjType = {
  "0": "正常",
  "1": "ロック",
};

/** MFA認証実施可否 */
export const IS_MFAAUTH: ObjType = { true: "実施する", false: "実施しない" };
